import { request } from "shared/helpers/sagas";
import { axiosInstance } from "network/apis";
import { isPMOrAdmin } from "shared/helpers/user";

export const sendSingleMessage = async ({ projectId, timeSlotId, action }) => {
  const editSessionUrl = `/project/${projectId}/time_slot/${timeSlotId}`;
  let sendSingleMessageUrl =
    action === "cancel"
      ? `${editSessionUrl}/cancel`
      : `${editSessionUrl}/reschedule`;
  if (isPMOrAdmin()) {
    sendSingleMessageUrl =
      action === "cancel"
        ? `${editSessionUrl}/pmCancel`
        : `${editSessionUrl}/pmReschedule`;
    if (action === "cancel") {
      action = "pmCancel";
    } else {
      action = "pmReschedule";
    }
  }
  return await axiosInstance.post(
    sendSingleMessageUrl,
    null,
    { params: { action: action } },
    { handlerEnabled: true }
  );
};

export function sendMultiMessage({ body, projectId, action }) {
  const editSessionUrl = `/v1/project/${projectId}`;
  const sendMultiMessageUrl =
    action === "cancel"
      ? `${editSessionUrl}/batch_cancel/finalize`
      : `${editSessionUrl}/batch_reschedule/finalize`;
  return request(sendMultiMessageUrl, "PUT", body);
}

export const getEmailTemplate = async (payload) => {
  return await axiosInstance.get(
    `project/${payload.projectId}/get_email_template`,
    {
      params: {
        reschedule: payload.forReschedule,
        addLink: payload.addLink,
        editLink: payload.editLink,
        responderLanguage: payload.responderLanguage,
        invalidateReschedule: payload.invalidateReschedule,
      },
    },
    { handlerEnabled: true }
  );
};

export const getInvalidateInterviewEmailTemplate = async (payload) => {
  return await axiosInstance.get(
    `project/${payload.projectId}/get_email_template`,
    {
      params: {
        invalidateReschedule: true,
      },
      handlerEnabled: true,
    }
  );
};

// Send invalidate-reschedule email only when rescheduling from Invalidated tab
export const sendInvalidateRescheduleMail = async ({ timeSlotId }) => {
  return await axiosInstance.post(
    "/interview/send_invalidate_reschedule_mail",
    { timeSlotId },
    { handlerEnabled: true }
  );
};

export default {
  sendSingleMessage,
  sendMultiMessage,
  getEmailTemplate,
  getInvalidateInterviewEmailTemplate,
  sendInvalidateRescheduleMail,
};
